import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Paper } from 'componets/ui';
import { CodeField, FormItem } from 'componets/form';
import { Login2FALayout } from 'componets/layouts';

import { CODE_LENGTH, Rules, ClientStatus, Paths } from 'utils/constants';

import { useAppSelector, useCodeForm, useTranslate } from 'hooks';

import { AppDispatch } from 'store';

import { login2FA } from 'features/authorization/actions';

import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg';

import s from '../index.module.scss';
import {useTranslation} from "react-i18next";

export const Login2FA: FC = () => {
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const tfa_token = useAppSelector((state) => state.authorization.tfaToken);
	const { fields, disabled, setFields, setIsValid, isValid, setDisabled, code } = useCodeForm();

	const dispatch = useDispatch<AppDispatch>();
	const { t } = useTranslation();

	useEffect(() => {
		if (isValid) {
			setDisabled(true);

			dispatch(login2FA({ code: code.value, tfa_token }))
				.unwrap()
				.then((r) => {
					navigate(r.status === ClientStatus.ACTIVE ? Paths.OVERVIEW : Paths.REGISTER);
				})
				.catch((e) => {
					setFields([{ ...code, errors: [t(e.message)] }]);
					setDisabled(false);
					setIsValid(false);
					form.resetFields();
				});
		}
	}, [code, dispatch, isValid, setDisabled, setFields, setIsValid]);

	const { backText, googleAuthenticatorText, googleAuthenticatorEnterText } = useTranslate([
		'backText',
		'googleAuthenticatorText',
		'googleAuthenticatorEnterText',
	]);

	return (
		<Login2FALayout>
			<Paper>
				<Typography.Title level={4}>{googleAuthenticatorText}</Typography.Title>
				<Typography.Text>{googleAuthenticatorEnterText}</Typography.Text>
				<Form form={form} onFieldsChange={setFields} fields={fields} className="modal-form">
					<FormItem className="code" name="code" rules={[Rules.REQUIRED]}>
						<CodeField
							name="code"
							fields={CODE_LENGTH}
							disabled={disabled}
							autoComplete="one-time-code"
						/>
					</FormItem>
				</Form>

				<div className={s.loginBack}>
					<button className="modal-backButton" type="button" onClick={() => navigate('/')}>
						<ArrowBack />
						{backText}
					</button>
				</div>
			</Paper>
		</Login2FALayout>
	);
};
